import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useDeleteBrandLogo, useUpdateBrandLogo, useUser } from '~/api/user';
import { Field } from '~/components/Form';
import { toast } from '~/utils/toast';

import { ImageUploadField } from '../../components/ImageUploadField';
import { layoutStyle, themeStyle } from './InvoiceTheme.css';
import { ThemePicker } from './ThemePicker/ThemePicker';

export const InvoiceTheme = () => {
  const { data: user } = useUser();
  const primaryBrand = user.brands[0];

  const updateMutation = useUpdateBrandLogo(primaryBrand.id);
  const deleteMutation = useDeleteBrandLogo(primaryBrand.id);
  const [pendingLogo, setPendingLogo] = useState<File | null>(null);

  const { t } = useTranslation(['settings']);

  const onUpload = (logo: File) => {
    const data = new FormData();
    data.append('logo', logo, logo.name);

    setPendingLogo(logo);
    updateMutation.mutate(data, {
      onError: () => toast.danger({ description: t('settings:fields.logo.error.upload') }),
      onSettled: () => setPendingLogo(null),
    });
  };

  const onDelete = () => {
    deleteMutation.mutate(undefined, { onError: () => toast.danger({ description: t('settings:fields.logo.error.delete') }) });
  };

  return (
    <div className={layoutStyle}>
      <ImageUploadField
        actionsLayout="row"
        deleteLabel={t('settings:imageUpload.logo.delete')}
        description={t('settings:general.themeInvoice.logo.helpText')}
        isDeleting={deleteMutation.isPending}
        isUploading={updateMutation.isPending}
        label={t('settings:imageUpload.logo.label')}
        onDelete={onDelete}
        onUpload={onUpload}
        pendingFile={pendingLogo}
        uploadLabel={t('settings:imageUpload.logo.upload')}
        url={primaryBrand.logo}
        variant="logo"
      />

      <div className={themeStyle}>
        <Field.Root>
          <Field.Label>{t('settings:general.themeInvoice.colorTheme.subtitle')}</Field.Label>

          <Field.Description>{t('settings:general.themeInvoice.colorTheme.helpText')}</Field.Description>
        </Field.Root>

        <ThemePicker />
      </div>
    </div>
  );
};
